import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { fetchProductAccessories } from 'b2b-apps/shop/product/redux/productAccessories/actionCreators';
import { getProductAccessoriesBySku } from 'b2b-apps/shop/product/redux/productAccessories/selectors';
import { ProductAccessoriesType } from 'b2b-apps/shop/product/redux/productAccessories/types';

type UseProductAccessoriesEffectReturnType = RemoteRecord<ProductAccessoriesType>;

const useProductAccessoriesEffect = (
  sku: string,
): UseProductAccessoriesEffectReturnType => {
  const dispatch = useDispatch();
  const accessories = useSelector(
    state => getProductAccessoriesBySku(state, sku),
  );

  useEffect(
    (): void => {
      if (!accessories.wasStarted) {
        dispatch(fetchProductAccessories(sku));
      }
    },
    [accessories.wasStarted, dispatch, sku],
  );

  return accessories;
};

export { useProductAccessoriesEffect };
export type { UseProductAccessoriesEffectReturnType };
